import { IDialogProps } from "@bps/fluent-ui";

import { JobsConfigurationDialog } from "./JobsConfigurationDialog";
import { JobsConfigurationJsonWrapper } from "./JobsConfigurationJsonWrapper";

interface JobsConfigurationHostProps extends Pick<IDialogProps, "onDismiss"> {
  value: string | undefined;
  onUpdate: (value: string) => void;
}

export const JobsConfigurationHost: React.FC<JobsConfigurationHostProps> = ({
  value,
  onUpdate,
  onDismiss
}) => {
  return (
    <JobsConfigurationDialog onDismiss={onDismiss}>
      <JobsConfigurationJsonWrapper
        value={value!}
        onDismiss={e => onDismiss?.(e)}
        onUpdate={onUpdate}
      />
    </JobsConfigurationDialog>
  );
};
